import InputList from './InputList'

export default InputList
